import { render, staticRenderFns } from "./logoutAccount.vue?vue&type=template&id=61e75a61&scoped=true"
import script from "./logoutAccount.vue?vue&type=script&lang=js"
export * from "./logoutAccount.vue?vue&type=script&lang=js"
import style0 from "./logoutAccount.vue?vue&type=style&index=0&id=61e75a61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e75a61",
  null
  
)

export default component.exports